import ChatFooter from './ChatFooter'

export default ChatFooter
